module.exports = __webpack_public_path__ + "ddd0e35741a008cf356a62ff785d96a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/selfie-stick.png
// module id = 2733
// module chunks = 0